export type BundleType = 'booth'|'video'|'mainstage'|'library'|'webinar'|'onsite booth'|'zoom appointment';
export const BUNDLE_TYPE_BOOTH:BundleType = 'booth';
export const BUNDLE_TYPE_VIDEO:BundleType = 'video';
export const BUNDLE_TYPE_MAINSTAGE:BundleType = 'mainstage';
export const BUNDLE_TYPE_LIBRARY:BundleType = 'library';
export const BUNDLE_TYPE_WEBINAR:BundleType = 'webinar';
export const BUNDLE_TYPE_ONSITE_BOOTH:BundleType = 'onsite booth';
export const BUNDLE_TYPE_ZOOM_APPOINTMENT:BundleType = 'zoom appointment';


export const bundleTypeOrEmptyForString = (type:string):BundleType|'' => {
  for(let i=0; i<bundleTypeOptions.length;i++) {
    const option = bundleTypeOptions[i];
    if(option.value===type) {
      return option.value;
    }
  }
  return '';
}

interface IBundleTypeOption {
  value:BundleType,
  label:string,
}
export const bundleTypeOptions:IBundleTypeOption[] = [
  { value:BUNDLE_TYPE_BOOTH, label:"Booth" },
  { value:BUNDLE_TYPE_VIDEO, label:"On Demand Video" },
  { value:BUNDLE_TYPE_MAINSTAGE, label:"Mainstage Session" },
  { value:BUNDLE_TYPE_LIBRARY, label:"Library Item" },
  { value:BUNDLE_TYPE_WEBINAR, label:"Webinar" },
  { value:BUNDLE_TYPE_ONSITE_BOOTH, label:"On-site Booth" },
  { value:BUNDLE_TYPE_ZOOM_APPOINTMENT, label:"Zoom Appointment"},
];
export const DEFAULT_BUNDLE_TYPE:BundleType = BUNDLE_TYPE_BOOTH;

export const bundleTypeOptionForString = (type:BundleType) => {
  for(let i=0; i<bundleTypeOptions.length;i++) {
    const option = bundleTypeOptions[i];
    if(option.value===type) {
      return option;
    }
  }
  return bundleTypeOptionForString(DEFAULT_BUNDLE_TYPE);
}